import { render, staticRenderFns } from "./viewFile.vue?vue&type=template&id=5c039b46&"
import script from "./viewFile.vue?vue&type=script&lang=js&"
export * from "./viewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports